import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { user_feed, user_update, user_update_reset, user_posts } from "../../redux/actions";
import SinglePostCard from "../../components/singlePostCard";
import {
  ButtonGroup,
  Container,
  Button,
  Col,
  Image,
  Form,
} from "react-bootstrap";

export default function LoggedInUserInfo() {
  const globalState = useSelector((state) => state);
  const dispatch = useDispatch();

  const [active, setActive] = useState("feed");
  const [formOpen, setFormOpen] = useState(false);
  const [updateForm, setUpdateForm] = useState({
    // ...updateForm,
    firstName: globalState.user.first_name,
    lastName: globalState.user.last_name,
    bio: globalState.user.bio,
    profileImageUrl: globalState.image,
  });

  useEffect(() => {
    setUpdateForm({
      ...updateForm,
      firstName: globalState.user.first_name,
      lastName: globalState.user.last_name,
      bio: globalState.user.bio,
      profileImageUrl: globalState.user.image,
    });
  }, [globalState.user]);

  useEffect(() => {
    dispatch(user_feed("get",   `${process.env.REACT_APP_URL}/api/articles/feed`));
  }, []);

  useEffect(() => {
    if (globalState.userDetailsUpdated) {
      setFormOpen(false);
    }
  }, [globalState.userDetailsUpdated]);

  function buttonOnClickHandler(type) {
    if (type === "feed") {
      setActive("feed");
      dispatch(user_feed("get", `${process.env.REACT_APP_URL}/api/articles/feed`));
    } else if (type === "info") {
      setActive("info");
    } else if (type === "post") {
      setActive("post");
      dispatch(user_posts("get", `${process.env.REACT_APP_URL}/api/articles?author=${globalState.user.id}`));
    } else if (type === "update") {
      if (formOpen) {
        const userUpdateObject = {
          user: {
            firstName: updateForm.firstName,
            lastName: updateForm.lastName,
            email: updateForm.email,
            imageUrl: updateForm.profileImageUrl,
            bio: updateForm.bio,
          },
        };
        setFormOpen(true);
        dispatch(
          user_update(
            "put",
            `${process.env.REACT_APP_URL}/api/user`,
            userUpdateObject
          ),
          userUpdateObject
        );
        dispatch(user_update_reset());
      }
      setFormOpen(true);
    } else if (type === "updateClose") {
      setFormOpen(false);
      setUpdateForm({
        ...updateForm,
        firstName: globalState.user.first_name,
        lastName: globalState.user.last_name,
        bio: globalState.user.bio,
        profileImageUrl: globalState.user.image,
      });
    }
  }

  function userFeedRender() {
    return globalState.userFeed ? (
      globalState.userFeed.map((item, index) => (
        <SinglePostCard key={index} item={item} />
      ))
    ) : (
      <div>Loading...</div>
    );
  }

  function onFormChange(e) {
    const { name, value } = e.target;
    if (name === "first_name") {
      setUpdateForm({
        ...updateForm,
        firstName: value,
      });
    } else if (name === "last_name") {
      setUpdateForm({
        ...updateForm,
        lastName: value,
      });
    } else if (name === "bio") {
      setUpdateForm({
        ...updateForm,
        bio: value,
      });
    } else if (name === "profile_image_url") {
      setUpdateForm({
        ...updateForm,
        profileImageUrl: value,
      });
    }
  }

  function userInfoRender() {
    return globalState.user ? (
      <div className="user-info">
        {formOpen ? (
          <div>
            <Form.Group className="mb-3" controlId="formBasicFirstName">
              <Form.Label>First Name:</Form.Label>
              <Form.Control
                onChange={onFormChange}
                name="first_name"
                type="text"
                value={updateForm.firstName}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicLastName">
              <Form.Label>Last Name:</Form.Label>
              <Form.Control
                onChange={onFormChange}
                name="last_name"
                type="text"
                value={updateForm.lastName}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicBio">
              <Form.Label>Bio</Form.Label>
              <Form.Control
                onChange={onFormChange}
                name="bio"
                as="textarea"
                type="text"
                value={updateForm.bio}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicImageUrl">
              <Form.Label>Profile Picture Url:</Form.Label>
              <Form.Control
                onChange={onFormChange}
                name="profile_image_url"
                type="text"
                value={updateForm.profileImageUrl}
              />
            </Form.Group>
          </div>
        ) : (
          <div>
            <Col xs={6} md={4}>
              <Image
                className="user-info-profile-image"
                fluid
                src={globalState.user.image}
                roundedCircle
              />
            </Col>
            <div>First Name: {globalState.user.first_name}</div>
            <div>Last Name: {globalState.user.last_name}</div>
            <div>Email: {globalState.user.email}</div>
            <div>Bio: {globalState.user.bio}</div>
          </div>
        )}
        <Button variant="dark" onClick={() => buttonOnClickHandler("update")}>
          {formOpen ? "Update" : "Update Info"}
        </Button>
        {formOpen && (
          <Button
            variant="dark"
            onClick={() => buttonOnClickHandler("updateClose")}
          >
            Close
          </Button>
        )}
      </div>
    ) : (
      <div>Loading...</div>
    );
  }

  function userPostRender() {
    return globalState.userPosts ? (
      globalState.userPosts.map((item, index) => (
        <SinglePostCard key={index} item={item} />
      ))
    ) : (
      <div>Loading...</div>
    );
  }

  return (
    <Container>
      <ButtonGroup aria-label="Basic example">
        <Button
          active={active === "feed"}
          variant="outline-dark"
          onClick={() => buttonOnClickHandler("feed")}
        >
          Your Feed
        </Button>
        <Button
          active={active === "post"}
          variant="outline-dark"
          onClick={() => buttonOnClickHandler("post")}
        >
          Your Posts
        </Button>
        <Button
          active={active === "info"}
          variant="outline-dark"
          onClick={() => buttonOnClickHandler("info")}
        >
          User Info
        </Button>
      </ButtonGroup>
      <div className="content-container">
        {active === "feed" && userFeedRender()}
        {active === "post" && userPostRender()}
        {active === "info" && userInfoRender()}
      </div>
    </Container>
  );
}
